// Nome do arquivo baixado vem do servidor, nunca montado no cliente — mesma regra do
// `DownloadFileService.getFilenameFromResponse` do Angular (download-file.service.ts), que lê o
// `Content-Disposition` da resposta e só usa um nome genérico (`download.<ext>`) quando o header
// não vem.
//
// Axios normaliza o nome dos headers para minúsculo, então a leitura é por 'content-disposition'
// (e não pela forma capitalizada que o `HttpResponse.headers.get()` do Angular usa).
//
// O backend manda nome com espaço e acento ("11530 - Granja Modelo.pdf"), que pode chegar entre
// aspas ou como `filename*=UTF-8''...` percent-encoded: sem tratar os dois casos o nome sai com
// aspas no meio ou percent-encoded no arquivo salvo.
export function getFilenameFromResponse(
  headers: Record<string, unknown> | undefined,
  fallbackFileName: string,
): string {
  const contentDisposition = headers?.['content-disposition'];
  if (typeof contentDisposition !== 'string') return fallbackFileName;

  const items = contentDisposition
    .split(';')
    .map((item) => item.trim())
    .filter(Boolean);

  const extended = items.find((item) => item.toLowerCase().startsWith('filename*='));
  if (extended) {
    const raw = extended.slice(extended.indexOf('=') + 1).trim();
    const encoded = raw.includes("''") ? raw.slice(raw.indexOf("''") + 2) : raw;
    try {
      const decoded = decodeURIComponent(encoded);
      if (decoded) return decoded;
    } catch {
      // percent-encoding inválido: cai no filename simples abaixo
    }
  }

  for (const item of items) {
    if (item.toLowerCase().startsWith('filename=')) {
      const value = item
        .slice(item.indexOf('=') + 1)
        .trim()
        .replace(/^"|"$/g, '');
      if (value) return value;
    }
  }
  return fallbackFileName;
}
